import React from "react";
import IconCloudDevOpsStrategy from "../../icons/icon-cloud-devOps-strategy.svg";
import IconDigitalProductsApps from "../../icons/icon-digital-products-apps-dt.svg";
import PageBannerImage from "../../images/digital-transformation-main-banner.svg";
import IconPuppet from "../../icons/icon-puppet.svg";
import IconAnsible from "../../icons/icon-ansible.svg";
import IconChef from "../../icons/icon-chef.svg";
import IconKubernates from "../../icons/icon-Kubernates.svg";
import IconIconkibanaDO from "../../icons/icon-kibanaDO.svg";
import IconDatadog from "../../icons/icon-datadog.svg";
import IconGrafana from "../../icons/icon-grafana.svg";
import IconDocker from "../../icons/icon-docker.svg";
import IconLinux from "../../icons/icon-linux.svg";
import IconJenkins from "../../icons/icon-jenkins.svg";
import IconGithub from "../../icons/icon-Github.svg";
import IconBitBucket from "../../icons/icon-BitBucket.svg";
import IconMaven from "../../icons/icon-Maven.svg";
import IconJava from "../../icons/icon-Java.svg";


import IconAwsColor from "../../icons/icon-aws-color.svg";
import IconAzureColor from "../../icons/icon-azure-color.svg";
import IconGcpColor from "../../icons/icon-gcp-color.svg";
import IconOracleColor from "../../icons/icon-oracle-color.svg";

import IconAutomateProcesses from "../../icons/icon-automate-processes-dt.svg";
import IconDigitizeProducts from "../../icons/icon-digitize-products-dt.svg";
import IconInnovationCulture from "../../icons/icon-innovation-culture-dt.svg";
import IconModernizeLegacy from "../../icons/icon-modernize-legacy-dt.svg";

import IconAIMachineLearning from "../../icons/icon-AI-machine-learning.svg";
import IconDataAnalyticsVisualization from "../../icons/icon-data-analytics-visualization.svg";
import IconDigitalTransformationStrategy from "../../icons/icon-digital-transformation-strategy.svg";
import IconRPAAutomations from "../../icons/icon-rpa-automations.svg";
import IconPersonalizationEngines from "../../icons/icon-personalization-engines-dt.svg";
import IconLanguageProcessing from "../../icons/icon-language-processing-dt.svg";
import IconDigitizeProcesses from "../../icons/icon-digitize-processes-dt.svg";

import ImageCB from "../../images/services-cs-cb.png";
import ImageKrogerHalf from "../../images/service-cs-kroger-half.jpg";
import ImageCBFlexprintHalf from "../../images/service-cs-flexprint-half.jpg";

import { Link } from "gatsby";

export const mainBannerObj = {
  classes: "digital-transformation",
  header: (<>Digital <br />Transformation</>),
  content: "Create the digital future of your business and industry by digitizing and automating your products, experiences, and operations, today!",
  mediaClass: "align-v-center justify-center",
  mediaType: "image",
  mediaSource: PageBannerImage
};

export const webBlockQuoteObj = {
  classes: "md-blockquote",
  quote: "Over the last 20 years, I've worked with many firms, onshore and offshore, and the team at Rapidops is the best that I have ever worked with. Rapidops’ team’s ability to understand the vision and translate it into digital products is mind-blowing.”",
  author: "Cheif Information Officer",
  occupation: "CIO, Manufacturing  Company",
};

export const pageIntroObj = {
  classes: "section-gap",
  title: "",
  header: (<>Leading the digital revolution</>),
  content: (<><p>Digital revolution is pushing businesses of every size and shape in all industries to reimagine their strategy and growth. With a continuous focus on digitization, automation, and customer experiences, the need for digital reinvention has expanded rapidly. It has become a non-negotiable requirement to find new growth and competitive advantage.</p>

    <p>We partner with global brands to rethink and reshape their businesses with next-gen digital strategy, innovation, and automation. We help our clients create products, platforms, and solutions that deliver personalized experiences, digitize processes and monetize their growing data with our end-to-end digital transformation expertise.</p></>)
};


export const gridlayoutObj = {
  classes: "devops-build three-row-three-col-grid",
  header: "Our capabilities",
  subHeader: (<>Our end-to-end solutions and services to help you lead the digital disruption.</>),
  gridItems: [
    {
      icon: <IconDigitalTransformationStrategy />,
      header: "Digital Transformation Strategy",
      content: "Create the future-proof strategy, roadmap, and working MVP that delivers the tangible impact and ROI that you need in less than 6 weeks"
    },
    {
      icon: <IconRPAAutomations />,
      header: "RPA & Smart Automation",
      content: "Improve operations and costs by automating the manual processes with Robotic Process Automation (RPA) and AI-powered processes"
    },
    {
      icon: <IconDigitalProductsApps />,
      header: "Digital Products & Apps",
      content: "Build tailor-made digital products, platforms, and solutions that are secure, flawless, and meticulously designed"
    },
    {
      icon: <IconPersonalizationEngines />,
      header: "Personalized Customer Experiences",
      content: "Grow your revenue and brand loyalty with outstanding products and service experiences unique to each customer"
    },
    {
      icon: <IconAIMachineLearning />,
      header: "AI & Machine Learning",
      content: "Leverage AI/ML, deep learning, and NLP to create intelligent products, experiences, and automation across all business functions"
    },
    {
      icon: <IconDataAnalyticsVisualization />,
      header: "Data Analytics & Visualization",
      content: "Transform your internal and external data into actionable insights that improve decisions, products, and processes"
    },
    {
      icon: <IconCloudDevOpsStrategy />,
      header: "Cloud & DevOps",
      content: "Embrace the power of Cloud platforms and DevOps automation to deliver faster, reliable, and more scalable products in record time"
    },
    {
      icon: <IconDigitizeProcesses />,
      header: "Digitize Processes",
      content: "Improve operational efficiencies by replacing old, paper-based, and human-driven processes with digital and automated operations "
    },
    {
      icon: <IconLanguageProcessing />,
      header: "IoT Analytics",
      content: "Use IoT devices and data to deliver real-time experiences, operational process, and create smart products and services"
    }
  ]
};


export const threeColSliderObj = {
  classes: "devops-opportunity",
  header: <>Here’s how we’ll help transform your business</>,
  subHeader: <>Leverage the full potential of technology, cloud, and AI to devise new efficiencies, opportunities, and experiences at all levels.</>,
  items: [
    {
      icon: <IconModernizeLegacy />,
      header: "Modernize Legacy",
      content: "Unlock new opportunities by re-imaging existing legacy systems & interfaces."
    }, {
      icon: <IconDigitizeProducts />,
      header: "Digitize Products",
      content: "Enhance your products & services using advanced digital technology and experiences."
    }, {
      icon: <IconAutomateProcesses />,
      header: "Automate Processes",
      content: "Use tech and data to automate manual work into scalable and cost-effective processes."
    }, {
      icon: <IconInnovationCulture />,
      header: "Innovation Culture",
      content: "Create strategy, processes, tools, team, and culture that fosters innovation - we act as the catalyst."
    }
  ]
};


export const techSliderObj = {
  classes: "md-technology devops-technology",
  items: [
    {
      link: "/",
      image: <IconPuppet />,
      name: "Puppet"
    }, {
      link: "/",
      image: <IconAnsible />,
      name: "Ansible"
    }, {
      link: "/",
      image: <IconChef />,
      name: "Chef"
    }, {
      link: "/",
      image: <IconKubernates />,
      name: "Kubernates"
    }, {
      link: "/",
      image: <IconIconkibanaDO />,
      name: "Kibana"
    }, {
      link: "/",
      image: <IconDatadog />,
      name: "DataDog"
    }, {
      link: "/",
      image: <IconGrafana />,
      name: "Grafana"
    }, {
      link: "/",
      image: <IconDocker />,
      name: "Docker"
    }, {
      link: "/",
      image: <IconLinux />,
      name: "Linux"
    }, {
      link: "/",
      image: <IconJenkins />,
      name: "Jenkins"
    }, {
      link: "/",
      image: <IconGithub />,
      name: "Github"
    }, {
      link: "/",
      image: <IconBitBucket />,
      name: "BitBucket"
    }, {
      link: "/",
      image: <IconMaven />,
      name: "Maven"
    }, {
      link: "/",
      image: <IconJava />,
      name: "Java"
    }
  ],
  platforms: [
    {
      icon: <IconAwsColor />,
      title: "AWS"
    }, {
      icon: <IconGcpColor />,
      title: "GDP"
    }, {
      icon: <IconAzureColor />,
      title: "Azure"
    },
    {
      icon: <IconOracleColor />,
      title: "Oracle"
    }
  ]
};

export const succesStoriesObj = {
  classesForFullColumn: "cs-cb",
  imageForFullColumn: ImageCB,
  imageAltForFullColumn: "Salesmate CRM Dashboard",
  imageTitleForFullColumn: "crm dashboard",
  categoryForFullColumn: "MANUFACTURING",
  headerForFullColumn: "Enabling digital evolution in manufacturing",
  subHeaderForFullColumn: (<>How we helped our client improve customer services and automate processes?</>),
  linkForFullColumn:'/work/digital-transformation-manufacturing/',
  
  classesForhalfColumn1: "cs-kroger-hlaf",
  imageForHalfColumn1: ImageKrogerHalf,
  imageAltForHalfColumn1: "custom voice automation retail",
  imageTitleForHalfColumn1: "Custom Voice Automation",
  categoryForHalfColumn1: "Retail",
  headerForHalfColumn1: "Voice-enabled shopping",
  linkForForHalfColumn1: '/work/kroger-grocery-shopping-voice-assistant/',

  classesForhalfColumn2: "cs-flexprint-hlaf",
  imageForHalfColumn2: ImageCBFlexprintHalf,
  imageAltForHalfColumn2: "Internet of things",
  imageTitleForHalfColumn2: "Iot",
  categoryForHalfColumn2: "B2B SERVICES",
  headerForHalfColumn2: "Transforming managed- printing with digital & IoT",
  linkForForHalfColumn2: '/work/transforming-managed-printing-with-iot-flexprint/',
};


export const ctaObj = {
  title: <>Ready to monetize digital transformation?</>,
  subtitle: <>Find your opportunities with our FREE <strong>rapidDiscovery</strong> bootcamp.</>,
};


